import IamApi from "api/IamApi";
import { VALIDATE_NAMESPACE } from "constants/i18n-namespaces";
import { useBiller } from "hooks";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  useNavigate,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import routing from "routing";
import { getDeviceFingerprint } from "selectors/appState";
import { ISession } from "types/session";
import { getDomain, mapSessionLanguageToUiLanguage } from "utilities/helper";

export const DirectLanding = () => {
  const [searchParams] = useSearchParams();
  const { loadBiller, getBiller } = useBiller();
  const biller = getBiller();
  const { login } = useOutletContext<ISession>();
  const { i18n } = useTranslation(VALIDATE_NAMESPACE);
  const fingerprint = useSelector(getDeviceFingerprint);

  const navigate = useNavigate();
  const domain = getDomain();
  const accountId = searchParams.get("AccountId");
  const accountKrn = searchParams.get("AccountKrn");
  const hash = searchParams.get("hash");
  const instanceId = searchParams.get("InstanceId");
  const spaceKrn = searchParams.get("SpaceKrn");
  const language = searchParams.get("Language");

  useEffect(() => {
    if (biller === null || biller === undefined) {
      loadBiller();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const directLanding = async () => {
      if (accountId && instanceId && hash && language) {
        IamApi.ezpay
          .postDirectLanding(
            {
              accountId: accountId,
              hash: hash,
            },
            instanceId,
            language,
            domain,
            fingerprint,
            navigator.userAgent
          )
          .then((response) => {
            const account = response.data;
            login({ ...account, fingerprint: fingerprint });
            const selectedLanguage = mapSessionLanguageToUiLanguage(
              language ?? "en"
            );
            i18n.changeLanguage(selectedLanguage);
            navigate(routing.balance.index());
          })
          .catch((error) => {
            console.log(error);
            // should be replace by error page once it is ready
            navigate(routing.index());
          });
      } else if (accountKrn && spaceKrn && hash && language) {
        IamApi.ezpay
          .postDirectLandingV2(
            {
              accountKrn: accountKrn,
              hash: hash,
            },
            spaceKrn,
            language,
            domain,
            fingerprint,
            navigator.userAgent
          )
          .then((response) => {
            const account = response.data;
            login({ ...account, fingerprint: fingerprint });
            const selectedLanguage = mapSessionLanguageToUiLanguage(
              language ?? "en"
            );
            i18n.changeLanguage(selectedLanguage);
            navigate(routing.balance.index());
          })
          .catch((error) => {
            console.log(error);
            // should be replace by error page once it is ready
            navigate(routing.index());
          });
      } else {
        navigate(routing.index());
      }
    };

    if (biller) {
      directLanding();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [biller]);

  return <></>;
};

export default DirectLanding;
